import { useEffect, useSyncExternalStore } from 'react';
import { captureHostInputs, micReadinessFacade } from './configure/host-inputs-facade';
import { useAudioGraphStore } from './useAudioGraphStore';

export const useAudioLevel = () => {
  const audioStatus = useAudioGraphStore((state) => state.audioStatus);
  const initializeAudioLevelMonitor = useAudioGraphStore(
    (state) => state.initializeAudioLevelMonitor
  );
  const releaseAudioLevelMonitor = useAudioGraphStore(
    (state) => state.releaseAudioLevelMonitor
  );
  // Host-supplied readiness source (monorepo wiring bridges the
  // readyToRequestMicPermissionsAtom); the server/unconfigured snapshot is
  // false — fail-safe: no monitor, no mic stream.
  const readyToRequestMic = useSyncExternalStore(
    micReadinessFacade.subscribe,
    micReadinessFacade.getSnapshot,
    () => false
  );

  useEffect(() => {
    // A native-capture host reads levels from its own recorder, so the web monitor
    // is unused. Initializing it opens a getUserMedia stream the webview never
    // releases, leaving the OS mic indicator lit outside recording.
    if (captureHostInputs.isNativeCaptureHost()) return;

    let monitorId: string | undefined;

    const setupMonitor = async () => {
      monitorId = await initializeAudioLevelMonitor();
    };

    if (readyToRequestMic) {
      void setupMonitor();
    }

    return () => {
      if (monitorId) releaseAudioLevelMonitor(monitorId);
    };
  }, [initializeAudioLevelMonitor, readyToRequestMic, releaseAudioLevelMonitor]);

  return audioStatus;
};
